<template>
    <sa-page-layout :btnSaveVisible="true" :btnAnnullaVisible="true" :linkback="linkback" :data="jsonData" :showModalLoading="showModalLoading" :pathResource="pathResource" class="sa-no-space">
        <template slot="table-body">
            <cot-pua-edit-component :showModalLoading="showModalLoading" @update="onUpdateJsonData" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></cot-pua-edit-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import CotPuaEditComponent from "../components/CotPuaEditComponent.vue";
export default {
    components: { SaPageLayout, CotPuaEditComponent },
    data() {
        return {
            showModalLoading: false,
            pathResource: "/cotpua",
            linkback: "/cot/pua",
            jsonData: {},
        };
    },
    methods: {
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
        onBeforeLoadData() {},
        onAfterLoadData() {},
    },
};
</script>

<style></style>
